function addZero (x) {
  return (x < 10) ? '0' + x : x
}

export default function getTime (cell) {
  let t = Math.floor(cell / 1000)
  let h = Math.floor(t / 3600)
  let m = Math.floor(t / 60) % 60
  let s = t % 60
  return `${addZero(h)}:${addZero(m)}:${addZero(s)}`
}
